import { EOffersForSelectionTypes, ISetOffersForSelectionSucceedPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setOffersSelectionSucceed = actionGenerator<
  EOffersForSelectionTypes.SetOffersSelectionSucceed,
  ISetOffersForSelectionSucceedPayload
>(EOffersForSelectionTypes.SetOffersSelectionSucceed);

export const setOffersSelectionPending = actionGenerator<EOffersForSelectionTypes.SetOffersSelectionPending, void>(
  EOffersForSelectionTypes.SetOffersSelectionPending,
);

export const setOffersSelectionFailed = actionGenerator<EOffersForSelectionTypes.SetOffersSelectionFailed, void>(
  EOffersForSelectionTypes.SetOffersSelectionFailed,
);

export const setOffersSelectionInitial = actionGenerator<EOffersForSelectionTypes.SetOffersSelectionInitial, void>(
  EOffersForSelectionTypes.SetOffersSelectionInitial,
);
